<template>
    <div id="login" v-if="initIsShowPopup">
        <div class="login_box">
            <img src="../assets/images/close.svg" alt="close" class="close" @click="closePopup">
            <h1>artube</h1>
            <input placeholder="이메일" class="id" v-model="email" @keyup.enter="loginSubmit">
            <input type="password" placeholder="비밀번호" class="pass"  v-model="password" @keyup.enter="loginSubmit">
            <div class="error_box">
                <p class="error" v-if="isShowError">{{errorMsg}}</p>
            </div>
            <!-- <div class="check_box">
                <input class="styled-checkbox" id="styled-checkbox-1" type="checkbox" value="value1">
                <label for="styled-checkbox-1">아이디 저장</label>
                <input class="styled-checkbox" id="styled-checkbox-2" type="checkbox" value="value2">
                <label for="styled-checkbox-2">로그인 유지</label>
            </div> -->
            <b-button class="login_button" @click="loginSubmit">로그인</b-button>
            <div class="util">
                <router-link tag="p" to="/Joinus" class="join">회원가입</router-link>
                <router-link tag="p" to="/Findpass">비밀번호 재설정</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Login',
    data(){
        return {
            email: "",         //아이디
            password: "",   //비밀번호

            isShowError: false,
            errorMsg: '',
        }
    },
    props: {
        initIsShowPopup: {
            type: Boolean,
            default: false
        }
    },
    created() {
    },
    mounted(){
    },
    beforeDestroy() {
	},
    methods: {
        closePopup(){
            this.email = '';
            this.password = '';
            this.$emit('close');
        },
        async loginSubmit() {

            this.isShowError = false;
            this.errorMsg = '';

            if (!this.email || !this.password) {

                this.isShowError = true;
                this.errorMsg = '이메일과 비밀번호를 입력해 주세요.';
                return;
            }

            let filter = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
            if(!filter.test(this.email)){
                this.errorMsg = '잘못된 이메일 형식 입니다.'
                this.isShowError = true;
                return;
            }

            var param = 
            {
                email: this.email,
                password: this.password
            }
            this.$Axios.post(`${this.host}/member/login`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(async(res) => {
                // console.log(res);
                if (res.data.returnCode === 0) {
                    await this.$store.commit("setEmail", this.email);
                    await this.$store.commit("loginTicket", res.data.ticket);
                    await this.$store.commit("loginSign", res.data.sign);
                    await this.$store.commit("setProfile", this.host);
                    this.email = '';
                    this.password = '';
                    // this.$emit("loginComplete");
                    location.reload();
                } 
                else if(res.data.returnCode === 41){
                    this.isShowError = true;
                    this.errorMsg = '존재하지 않는 회원정보 입니다.';
                }
                else if(res.data.returnCode === 46){
                    this.isShowError = true;
                    this.errorMsg = '이미 탈퇴한 계정입니다.';
                }
                else if(res.data.returnCode === 90 || res.data.returnCode === 91 || res.data.returnCode === 92){
                    this.isShowError = true;
                    this.errorMsg = '비밀번호를 다시 확인해 주세요.';
                }
                else {
                    console.log(res.data.description);

                    this.isShowError = true;
                    this.errorMsg = '로그인 실패, 잠시 후 다시 시도해 주세요.';
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
    },
}
</script>